import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/galleryActivity'

export const galleryActivityservice = {
    search,
    getItem,
    saveItem,
    updateItem,
    deleteItem,
    setDefault,
};

function search(data) {
    return utilHelper.doRequest(`${relativeUrl}/search`, 'POST', data)
}

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET');
}

function saveItem(data) {
    return utilHelper.doRequest(`${relativeUrl}`, 'POST', data);
}

function updateItem(id, data) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'PUT', data);
}

function deleteItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'DELETE')
}

function setDefault(data) {
    return utilHelper.doRequest(`${relativeUrl}/setDefault`, 'POST', data);
}